import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { TransportOrderOverviewData } from '../../models/transport-order-overview.model';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { NotificationService } from '../../../../../common/services/notification/notification.service';
import { Error, CustomHttpErrorResponse } from '../../../../../common/constants/error';
import { TransportOrderOverviewLoad, TransportOrderOverviewSetInitialState } from './transport-order-overview.actions';
import { TransportOrderOverviewService } from './transport-order-overview.service';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface TransportOrderOverviewStateModel {
  overview: TransportOrderOverviewData;
  loaded: boolean;
}

const initialState: TransportOrderOverviewStateModel = {
  overview: null,
  loaded: false,
};

@State<TransportOrderOverviewStateModel>({
  name: 'transportOrderOverview',
  defaults: initialState,
})
@Injectable()
export class TransportOrderOverviewState {
  constructor(
    private transportOrderOverviewService: TransportOrderOverviewService,
    private notificationService: NotificationService,
  ) {}

  @Selector()
  static getLoaded(state: TransportOrderOverviewStateModel): boolean {
    return state.loaded;
  }

  @Selector()
  static getOverview(state: TransportOrderOverviewStateModel): TransportOrderOverviewData {
    return state.overview;
  }

  @Action(TransportOrderOverviewLoad)
  loadOverview(
    ctx: StateContext<TransportOrderOverviewStateModel>,
    { payload }: TransportOrderOverviewLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.transportOrderOverviewService.getOverview(payload).pipe(
      map((overview: TransportOrderOverviewData) => {
        ctx.patchState({ overview, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(TransportOrderOverviewSetInitialState)
  setInitialState(ctx: StateContext<TransportOrderOverviewStateModel>): void {
    ctx.setState(initialState);
  }
}
